import * as React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";
import { cssInterop } from "nativewind";

cssInterop(Svg, {
  className: {
    target: "style",
    nativeStyleToProp: { width: true, height: true },
  },
});

cssInterop(Path, {
  className: {
    // @ts-ignore
    target: "style",
    nativeStyleToProp: { stroke: true },
  },
});

type EyeOffIconProps = SvgProps & {
  className?: string;
  pathClassName?: string;
};

function EyeOffIcon({
  className,
  pathClassName = "stroke-white",
  ...props
}: EyeOffIconProps) {
  return (
    <Svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <Path
        d="M5.45 16.92a10.78 10.78 0 01-2.55-3.71 1.85 1.85 0 010-1.46A10.59 10.59 0 016.62 7.1 9 9 0 0112 5.48a8.81 8.81 0 014 .85M18.56 8.05a10.85 10.85 0 012.54 3.7 1.85 1.85 0 010 1.46 10.59 10.59 0 01-3.72 4.65A9 9 0 0112 19.48a8.81 8.81 0 01-4-.85"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M8.71 13.65a3.28 3.28 0 01-.21-1.17 3.5 3.5 0 013.5-3.5c.4-.001.796.07 1.17.21M15.29 11.31c.14.374.212.77.21 1.17a3.5 3.5 0 01-3.5 3.5 3.28 3.28 0 01-1.17-.21M3 20L19 4"
        className={pathClassName}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default EyeOffIcon;
